import { Icon, Typography } from '@repo/ui';
import { useSuspenseQueries } from '@tanstack/react-query';
import c from 'classnames';
import { userValueFormat } from 'helpers';
import { getActionsForSubMetric } from 'helpers/submetrics/getActionsForSubMetric';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import { useLocation, useNavigate } from 'react-router-dom';
import { getActionPlanItemsQuery } from 'services/actionPlan/actionPlanData';
import type Metric from 'types/Metric';
import { getEvaluationIconFromColor } from '../../Insights/EvaluationGroupsSummary/EvaluationGroupsSummary';
import styles from './ConditionMetricRow.legacy.module.css';

export const LegacyConditionMetricRow = ({
  metric,
  row,
}: {
  metric: Metric;
  row: number;
}) => {
  const { currentKitId } = useCurrentKitAndTinyAccount();

  const [{ data: allActions }] = useSuspenseQueries({
    queries: [getActionPlanItemsQuery(currentKitId)],
  });

  const actionItems = getActionsForSubMetric(allActions, metric.metric_id);

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const navigateToSubmetric = () => {
    navigate(
      `/results/${currentKitId}/insights/all-insights/${metric.metric_id}`,
      { state: { from: pathname } },
    );
  };

  return (
    <div
      className={c(styles.metricRow, row !== 0 && styles.borderTop)}
      onClick={() => {
        navigateToSubmetric();
      }}
    >
      <div className={styles.metricName}>
        <div className={styles.metricNameInner}>
          <Icon
            name={getEvaluationIconFromColor(metric.evaluation_color)}
            size='s'
            className={c(styles.icon, styles[metric.evaluation_color])}
          />
          <Typography variant='body-s' className={styles.metricNameText}>
            {metric.name}
          </Typography>
        </div>
        <Typography variant='body-s' className={styles.actions}>
          {actionItems.length ? `${actionItems.length} metric actions` : null}
        </Typography>
      </div>

      <div className={styles.metricData}>
        <div
          className={c(
            styles.relAbun,
            styles[`text-${metric.evaluation_color}`],
          )}
        >
          {userValueFormat(metric.user_value, metric.data_type)}
        </div>
        <Icon name='chevronForward' size='xs' />
      </div>
    </div>
  );
};
